import { useState, useEffect } from 'react';
import axios from '../api/axios';

const useOnboardingStatus = () => {
    const [steps, setSteps] = useState({ hasCards: false, hasTeam: false, beatTutorial: false });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get('/users/onboarding')
            .then(res => setSteps(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const done = steps.hasCards && steps.hasTeam && steps.beatTutorial;

    return { done, loading, steps };
};

export default useOnboardingStatus;
